/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AccessRestrictionModel } from '@coin/shared/core/util-models-v2';
import { CreateAndUpdateOrganisationsStatus } from '@coin/shared/core/util-models-v2';
import { CreateMasterData } from '@coin/shared/core/util-models-v2';
import { EntitySearchScope } from '@coin/shared/core/util-models-v2';
import { LinemanagerDeviationsReport } from '@coin/shared/core/util-models-v2';
import { MassChangeDelete } from '@coin/shared/core/util-models-v2';
import { MassChangeStartAndEndDate } from '@coin/shared/core/util-models-v2';
import { MasterData } from '@coin/shared/core/util-models-v2';
import { MasterDataFieldValues } from '@coin/shared/core/util-models-v2';
import { MonitoringReport } from '@coin/shared/core/util-models-v2';
import { PageOfOrganisationManagementActivityStream } from '@coin/shared/core/util-models-v2';
import { PageOfOrganisationManagementOrganisationsOrganisation } from '@coin/shared/core/util-models-v2';
import { PageOfString } from '@coin/shared/core/util-models-v2';
import { PositionTypeTerminationSimulation } from '@coin/shared/core/util-models-v2';
import { ReportConfiguration } from '@coin/shared/core/util-models-v2';
import { RuleSet } from '@coin/shared/core/util-models-v2';
import { RulesRule } from '@coin/shared/core/util-models-v2';
import { SeomStructureListReport } from '@coin/shared/core/util-models-v2';
import { SetAccessRestriction } from '@coin/shared/core/util-models-v2';
import { SetAccessRestrictionsCommand } from '@coin/shared/core/util-models-v2';
import { SpanOfControlReport } from '@coin/shared/core/util-models-v2';
import { StatusResponse } from '@coin/shared/core/util-models-v2';
import { TransactionStatusDto } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfExportStatusMetadata } from '@coin/shared/core/util-models-v2';
import { UpdateMasterData } from '@coin/shared/core/util-models-v2';
import { ValidateOrganisations } from '@coin/shared/core/util-models-v2';
import { ValidationResult } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface CreateMasterDataParams {
  createMasterData?: CreateMasterData;
}

export interface CreateReportConfigurationReportsParams {
  reportConfiguration?: ReportConfiguration;
}

export interface CreateRulesParams {
  rulesRule?: RulesRule;
}

export interface DeleteRulesParams {
  id: string;
}

export interface ExportLineManagerDeviationsReportReportsParams {
  linemanagerDeviationsReport?: LinemanagerDeviationsReport;
}

export interface ExportMonitoringReportReportsParams {
  monitoringReport?: MonitoringReport;
}

export interface ExportSeomStructureListReportReportsParams {
  seomStructureListReport?: SeomStructureListReport;
}

export interface ExportSpanOfControlReportReportsParams {
  spanOfControlReport?: SpanOfControlReport;
}

export interface ExportToDataHubOrganisationsParams {
  fullExport?: boolean;
}

export interface GetDataHubExportSubTransactionsOrganisationsParams {
  transactionId: string;
}

export interface GetFieldValuesMasterDataParams {
  commentSearch?: string;
  typeFilter?: string;
  valueSearch?: string;
  validFrom?: string;
  validTo?: string;
}

export interface GetFieldValuesRulesParams {
  field: string;
  orgName?: string;
  orgCode?: string;
  parentOrgCode?: string;
  orgLevel?: number;
  orgUnit?: string;
  orgClass?: string;
  orgType?: string;
  validFrom?: string;
  validTo?: string;
  page?: number;
  size?: number;
}

export interface GetMasterDataParams {
  commentSearch?: string;
  typeFilter?: string;
  valueSearch?: string;
  validFrom?: string;
  validTo?: string;
}

export interface GetReportConfigurationReportsParams {
  reportType: string;
}

export interface GetRulesParams {
  queryTitle?: string;
  queryType?: Array<string>;
  querySeverity?: Array<'Error' | 'Warning' | 'Information'>;
  queryValidationType?: Array<
    | 'OrgNameMatchOrgCodeAbbreviation'
    | 'ProhibitedOrgCodeAbbreviation'
    | 'ProhibitedOrgName'
    | 'EmptyHeadPosition'
    | 'OnlyOneHeadPosition'
    | 'MaximumOrgLevel'
    | 'InheritancePrinciple'
    | 'InvalidContractStatus'
    | 'InvalidWorkforceType'
    | 'OrgCodeAbbreviationMatchOrgName'
    | 'ProhibitedUseOfSubRegion'
    | 'NumberAsOrgCodeOnlyOnLowestLevel'
  >;
  queryConfiguration?: string;
  queryMessage?: string;
  queryIsActive?: boolean;
  queryValidFrom?: string;
  queryValidTo?: string;
  sortableOrderBy?: 'Asc' | 'Desc';
  sortableProperty?: string;
}

export interface OrganisationManagementAdminDeleteOrganisationsParams {
  massChangeDelete?: MassChangeDelete;
}

export interface OrganisationManagementAdminUpdateOrganisationsParams {
  massChangeStartAndEndDate?: MassChangeStartAndEndDate;
}

export interface QueryMasterDataActivityStreamParams {
  page?: number;
  size?: number;
}

export interface QueryRuleActivityStreamParams {
  page?: number;
  size?: number;
}

export interface RevokeAccessRestrictionsAccessRestrictionsParams {
  restrictionId?: string;
}

export interface SetAccessRestrictionsAccessRestrictionsParams {
  setAccessRestrictionsCommand?: SetAccessRestrictionsCommand;
}

export interface SimulateRulesParams {
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  ruleSet?: RuleSet;
}

export interface SimulateTerminatePositionsParams {
  /** Filter for given position title */
  title?: string;
  /** The date of termination */
  validOn?: string;
  validOnDate?: string;
}

export interface TerminateMasterDataParams {
  id: string;
  validTo?: string;
  type?: string;
}

export interface UpdateMasterDataParams {
  id: string;
  updateMasterData?: UpdateMasterData;
}

export interface UpdateReportConfigurationReportsParams {
  reportType: string;
  reportConfiguration?: ReportConfiguration;
}

export interface UpdateRulesParams {
  id: string;
  rulesRule?: RulesRule;
}

export interface ValidateOrganisationsOrganisationsParams {
  validateOrganisations?: ValidateOrganisations;
}

@Injectable({
  providedIn: 'root'
})
export class OrganisationManagementAdminService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createMasterData(
    requestParameters?: CreateMasterDataParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MasterData>;
  public createMasterData(
    requestParameters?: CreateMasterDataParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MasterData>>;
  public createMasterData(
    requestParameters?: CreateMasterDataParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MasterData>>;
  public createMasterData(requestParameters?: CreateMasterDataParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-management/admin/v1/master-data/create`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createMasterData,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Create a new report
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createReportConfigurationReports(
    requestParameters?: CreateReportConfigurationReportsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ReportConfiguration>;
  public createReportConfigurationReports(
    requestParameters?: CreateReportConfigurationReportsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ReportConfiguration>>;
  public createReportConfigurationReports(
    requestParameters?: CreateReportConfigurationReportsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ReportConfiguration>>;
  public createReportConfigurationReports(
    requestParameters?: CreateReportConfigurationReportsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-management/admin/v1/reports`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.reportConfiguration,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Create Rule
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createRules(
    requestParameters?: CreateRulesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<RulesRule>;
  public createRules(
    requestParameters?: CreateRulesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<RulesRule>>;
  public createRules(
    requestParameters?: CreateRulesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<RulesRule>>;
  public createRules(requestParameters?: CreateRulesParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-management/admin/v1/rules`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.rulesRule,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Delete Rule
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteRules(
    requestParameters?: DeleteRulesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public deleteRules(
    requestParameters?: DeleteRulesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public deleteRules(
    requestParameters?: DeleteRulesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public deleteRules(requestParameters?: DeleteRulesParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('deleteRules', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/organisation-management/admin/v1/rules/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Export monitoring report
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportLineManagerDeviationsReportReports(
    requestParameters?: ExportLineManagerDeviationsReportReportsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportLineManagerDeviationsReportReports(
    requestParameters?: ExportLineManagerDeviationsReportReportsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportLineManagerDeviationsReportReports(
    requestParameters?: ExportLineManagerDeviationsReportReportsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportLineManagerDeviationsReportReports(
    requestParameters?: ExportLineManagerDeviationsReportReportsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-management/admin/v1/reports/linemanager-deviations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.linemanagerDeviationsReport,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Export monitoring report
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportMonitoringReportReports(
    requestParameters?: ExportMonitoringReportReportsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportMonitoringReportReports(
    requestParameters?: ExportMonitoringReportReportsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportMonitoringReportReports(
    requestParameters?: ExportMonitoringReportReportsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportMonitoringReportReports(
    requestParameters?: ExportMonitoringReportReportsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-management/admin/v1/reports/monitoring`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.monitoringReport,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Export given seom structure list report
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportSeomStructureListReportReports(
    requestParameters?: ExportSeomStructureListReportReportsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportSeomStructureListReportReports(
    requestParameters?: ExportSeomStructureListReportReportsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportSeomStructureListReportReports(
    requestParameters?: ExportSeomStructureListReportReportsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportSeomStructureListReportReports(
    requestParameters?: ExportSeomStructureListReportReportsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-management/admin/v1/reports/seom-structure-list`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.seomStructureListReport,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Export given span of control report
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportSpanOfControlReportReports(
    requestParameters?: ExportSpanOfControlReportReportsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportSpanOfControlReportReports(
    requestParameters?: ExportSpanOfControlReportReportsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportSpanOfControlReportReports(
    requestParameters?: ExportSpanOfControlReportReportsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportSpanOfControlReportReports(
    requestParameters?: ExportSpanOfControlReportReportsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-management/admin/v1/reports/span-of-control`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.spanOfControlReport,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Export data to DataHub
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportToDataHubOrganisations(
    requestParameters?: ExportToDataHubOrganisationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportToDataHubOrganisations(
    requestParameters?: ExportToDataHubOrganisationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportToDataHubOrganisations(
    requestParameters?: ExportToDataHubOrganisationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportToDataHubOrganisations(
    requestParameters?: ExportToDataHubOrganisationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-management/admin/v1/organisations/export/datahub`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { fullExport: requestParameters?.fullExport }
    });
  }

  /**
   * Get Access Restrictions
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAccessRestrictionsAccessRestrictions(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<AccessRestrictionModel>>;
  public getAccessRestrictionsAccessRestrictions(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<AccessRestrictionModel>>>;
  public getAccessRestrictionsAccessRestrictions(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<AccessRestrictionModel>>>;
  public getAccessRestrictionsAccessRestrictions(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/v1/organisation-management/access-restriction`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Returns the subtransactions of a DataHub export, including Pending entries for the organisation import consumers that have not registered theirs yet.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDataHubExportSubTransactionsOrganisations(
    requestParameters?: GetDataHubExportSubTransactionsOrganisationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<TransactionStatusDto>>;
  public getDataHubExportSubTransactionsOrganisations(
    requestParameters?: GetDataHubExportSubTransactionsOrganisationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<TransactionStatusDto>>>;
  public getDataHubExportSubTransactionsOrganisations(
    requestParameters?: GetDataHubExportSubTransactionsOrganisationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<TransactionStatusDto>>>;
  public getDataHubExportSubTransactionsOrganisations(
    requestParameters?: GetDataHubExportSubTransactionsOrganisationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const transactionId = requestParameters?.transactionId;
    this.checkRequired('getDataHubExportSubTransactionsOrganisations', { transactionId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-management/admin/v1/organisations/export/datahub/transactions/${this.configuration.encodeParam({ name: 'transactionId', value: transactionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/sub-transactions`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Get master data field values
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getFieldValuesMasterData(
    requestParameters?: GetFieldValuesMasterDataParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MasterDataFieldValues>;
  public getFieldValuesMasterData(
    requestParameters?: GetFieldValuesMasterDataParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MasterDataFieldValues>>;
  public getFieldValuesMasterData(
    requestParameters?: GetFieldValuesMasterDataParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MasterDataFieldValues>>;
  public getFieldValuesMasterData(
    requestParameters?: GetFieldValuesMasterDataParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-management/admin/v1/master-data/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        CommentSearch: requestParameters?.commentSearch,
        TypeFilter: requestParameters?.typeFilter,
        ValueSearch: requestParameters?.valueSearch,
        ValidFrom: requestParameters?.validFrom,
        ValidTo: requestParameters?.validTo
      }
    });
  }

  /**
   * Get field values
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getFieldValuesRules(
    requestParameters?: GetFieldValuesRulesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public getFieldValuesRules(
    requestParameters?: GetFieldValuesRulesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public getFieldValuesRules(
    requestParameters?: GetFieldValuesRulesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public getFieldValuesRules(requestParameters?: GetFieldValuesRulesParams, ...args: RequestArgs): Observable<any> {
    const field = requestParameters?.field;
    this.checkRequired('getFieldValuesRules', { field });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-management/admin/v1/rules/field-values/${this.configuration.encodeParam({ name: 'field', value: field, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        OrgName: requestParameters?.orgName,
        OrgCode: requestParameters?.orgCode,
        ParentOrgCode: requestParameters?.parentOrgCode,
        OrgLevel: requestParameters?.orgLevel,
        OrgUnit: requestParameters?.orgUnit,
        OrgClass: requestParameters?.orgClass,
        OrgType: requestParameters?.orgType,
        ValidFrom: requestParameters?.validFrom,
        ValidTo: requestParameters?.validTo,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * Returns the most recently started DataHub export transaction (running, finished or failed). Its state and progress cover all its subtransactions, including the organisation import consumers\&#39;, which are listed by the sub-transactions endpoint.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getLatestDataHubExportTransactionOrganisations(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public getLatestDataHubExportTransactionOrganisations(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public getLatestDataHubExportTransactionOrganisations(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public getLatestDataHubExportTransactionOrganisations(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-management/admin/v1/organisations/export/datahub/latest-transaction`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Get master data as list
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getMasterData(
    requestParameters?: GetMasterDataParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<MasterData>>;
  public getMasterData(
    requestParameters?: GetMasterDataParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<MasterData>>>;
  public getMasterData(
    requestParameters?: GetMasterDataParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<MasterData>>>;
  public getMasterData(requestParameters?: GetMasterDataParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-management/admin/v1/master-data`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        CommentSearch: requestParameters?.commentSearch,
        TypeFilter: requestParameters?.typeFilter,
        ValueSearch: requestParameters?.valueSearch,
        ValidFrom: requestParameters?.validFrom,
        ValidTo: requestParameters?.validTo
      }
    });
  }

  /**
   * Get Information of report
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getReportConfigurationReports(
    requestParameters?: GetReportConfigurationReportsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ReportConfiguration>;
  public getReportConfigurationReports(
    requestParameters?: GetReportConfigurationReportsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ReportConfiguration>>;
  public getReportConfigurationReports(
    requestParameters?: GetReportConfigurationReportsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ReportConfiguration>>;
  public getReportConfigurationReports(
    requestParameters?: GetReportConfigurationReportsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const reportType = requestParameters?.reportType;
    this.checkRequired('getReportConfigurationReports', { reportType });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-management/admin/v1/reports/${this.configuration.encodeParam({ name: 'reportType', value: reportType, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Get all Rules
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getRules(
    requestParameters?: GetRulesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<RulesRule>>;
  public getRules(
    requestParameters?: GetRulesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<RulesRule>>>;
  public getRules(
    requestParameters?: GetRulesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<RulesRule>>>;
  public getRules(requestParameters?: GetRulesParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-management/admin/v1/rules`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.Title': requestParameters?.queryTitle,
        'Query.Type': requestParameters?.queryType,
        'Query.Severity': requestParameters?.querySeverity,
        'Query.ValidationType': requestParameters?.queryValidationType,
        'Query.Configuration': requestParameters?.queryConfiguration,
        'Query.Message': requestParameters?.queryMessage,
        'Query.IsActive': requestParameters?.queryIsActive,
        'Query.ValidFrom': requestParameters?.queryValidFrom,
        'Query.ValidTo': requestParameters?.queryValidTo,
        'Sortable.OrderBy': requestParameters?.sortableOrderBy,
        'Sortable.Property': requestParameters?.sortableProperty
      }
    });
  }

  /**
   * Get Search Scope for Rules
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getScopeActivityStream(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EntitySearchScope>;
  public getScopeActivityStream(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EntitySearchScope>>;
  public getScopeActivityStream(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EntitySearchScope>>;
  public getScopeActivityStream(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-management/admin/v1/activity-stream/scope`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Get Search Scope for Rules
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getScopeRules(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EntitySearchScope>;
  public getScopeRules(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EntitySearchScope>>;
  public getScopeRules(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EntitySearchScope>>;
  public getScopeRules(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-management/admin/v1/rules/scope`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Delete Organisations
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationManagementAdminDeleteOrganisations(
    requestParameters?: OrganisationManagementAdminDeleteOrganisationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<CreateAndUpdateOrganisationsStatus>;
  public organisationManagementAdminDeleteOrganisations(
    requestParameters?: OrganisationManagementAdminDeleteOrganisationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<CreateAndUpdateOrganisationsStatus>>;
  public organisationManagementAdminDeleteOrganisations(
    requestParameters?: OrganisationManagementAdminDeleteOrganisationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<CreateAndUpdateOrganisationsStatus>>;
  public organisationManagementAdminDeleteOrganisations(
    requestParameters?: OrganisationManagementAdminDeleteOrganisationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/organisation-management/admin/v1/organisations/delete`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.massChangeDelete,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Change Start and EndDate (ValidFrom, ValidTo)
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationManagementAdminUpdateOrganisations(
    requestParameters?: OrganisationManagementAdminUpdateOrganisationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<CreateAndUpdateOrganisationsStatus>;
  public organisationManagementAdminUpdateOrganisations(
    requestParameters?: OrganisationManagementAdminUpdateOrganisationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<CreateAndUpdateOrganisationsStatus>>;
  public organisationManagementAdminUpdateOrganisations(
    requestParameters?: OrganisationManagementAdminUpdateOrganisationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<CreateAndUpdateOrganisationsStatus>>;
  public organisationManagementAdminUpdateOrganisations(
    requestParameters?: OrganisationManagementAdminUpdateOrganisationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/organisation-management/admin/v1/organisations/publish`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.massChangeStartAndEndDate,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Gets the activity stream for master data.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryMasterDataActivityStream(
    requestParameters?: QueryMasterDataActivityStreamParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfOrganisationManagementActivityStream>;
  public queryMasterDataActivityStream(
    requestParameters?: QueryMasterDataActivityStreamParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfOrganisationManagementActivityStream>>;
  public queryMasterDataActivityStream(
    requestParameters?: QueryMasterDataActivityStreamParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfOrganisationManagementActivityStream>>;
  public queryMasterDataActivityStream(
    requestParameters?: QueryMasterDataActivityStreamParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-management/admin/v1/activity-stream/master-data`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * Gets the activity stream for rules.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryRuleActivityStream(
    requestParameters?: QueryRuleActivityStreamParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfOrganisationManagementActivityStream>;
  public queryRuleActivityStream(
    requestParameters?: QueryRuleActivityStreamParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfOrganisationManagementActivityStream>>;
  public queryRuleActivityStream(
    requestParameters?: QueryRuleActivityStreamParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfOrganisationManagementActivityStream>>;
  public queryRuleActivityStream(
    requestParameters?: QueryRuleActivityStreamParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-management/admin/v1/activity-stream/rules`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * Revoke Access Restrictions
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public revokeAccessRestrictionsAccessRestrictions(
    requestParameters?: RevokeAccessRestrictionsAccessRestrictionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<boolean>;
  public revokeAccessRestrictionsAccessRestrictions(
    requestParameters?: RevokeAccessRestrictionsAccessRestrictionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<boolean>>;
  public revokeAccessRestrictionsAccessRestrictions(
    requestParameters?: RevokeAccessRestrictionsAccessRestrictionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<boolean>>;
  public revokeAccessRestrictionsAccessRestrictions(
    requestParameters?: RevokeAccessRestrictionsAccessRestrictionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/v1/organisation-management/access-restriction`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { RestrictionId: requestParameters?.restrictionId }
    });
  }

  /**
   * Set Access Restrictions
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public setAccessRestrictionsAccessRestrictions(
    requestParameters?: SetAccessRestrictionsAccessRestrictionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SetAccessRestriction>;
  public setAccessRestrictionsAccessRestrictions(
    requestParameters?: SetAccessRestrictionsAccessRestrictionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SetAccessRestriction>>;
  public setAccessRestrictionsAccessRestrictions(
    requestParameters?: SetAccessRestrictionsAccessRestrictionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SetAccessRestriction>>;
  public setAccessRestrictionsAccessRestrictions(
    requestParameters?: SetAccessRestrictionsAccessRestrictionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/v1/organisation-management/access-restriction`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.setAccessRestrictionsCommand,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Simulate a rule set
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public simulateRules(
    requestParameters?: SimulateRulesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfOrganisationManagementOrganisationsOrganisation>;
  public simulateRules(
    requestParameters?: SimulateRulesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfOrganisationManagementOrganisationsOrganisation>>;
  public simulateRules(
    requestParameters?: SimulateRulesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfOrganisationManagementOrganisationsOrganisation>>;
  public simulateRules(requestParameters?: SimulateRulesParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-management/admin/v1/rules/simulate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      },
      body: requestParameters?.ruleSet,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Get a list of all Positions that collide with expected termination
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public simulateTerminatePositions(
    requestParameters?: SimulateTerminatePositionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<PositionTypeTerminationSimulation>>;
  public simulateTerminatePositions(
    requestParameters?: SimulateTerminatePositionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<PositionTypeTerminationSimulation>>>;
  public simulateTerminatePositions(
    requestParameters?: SimulateTerminatePositionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<PositionTypeTerminationSimulation>>>;
  public simulateTerminatePositions(
    requestParameters?: SimulateTerminatePositionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-management/admin/v1/positions/types/simulate-terminate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Title: requestParameters?.title,
        ValidOn: requestParameters?.validOn,
        ValidOnDate: requestParameters?.validOnDate
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public terminateMasterData(
    requestParameters?: TerminateMasterDataParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MasterData>;
  public terminateMasterData(
    requestParameters?: TerminateMasterDataParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MasterData>>;
  public terminateMasterData(
    requestParameters?: TerminateMasterDataParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MasterData>>;
  public terminateMasterData(requestParameters?: TerminateMasterDataParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('terminateMasterData', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/organisation-management/admin/v1/master-data/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/terminate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { ValidTo: requestParameters?.validTo, Type: requestParameters?.type }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateMasterData(
    requestParameters?: UpdateMasterDataParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MasterData>;
  public updateMasterData(
    requestParameters?: UpdateMasterDataParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MasterData>>;
  public updateMasterData(
    requestParameters?: UpdateMasterDataParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MasterData>>;
  public updateMasterData(requestParameters?: UpdateMasterDataParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateMasterData', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/organisation-management/admin/v1/master-data/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/update`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateMasterData,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Update a report
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateReportConfigurationReports(
    requestParameters?: UpdateReportConfigurationReportsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ReportConfiguration>;
  public updateReportConfigurationReports(
    requestParameters?: UpdateReportConfigurationReportsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ReportConfiguration>>;
  public updateReportConfigurationReports(
    requestParameters?: UpdateReportConfigurationReportsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ReportConfiguration>>;
  public updateReportConfigurationReports(
    requestParameters?: UpdateReportConfigurationReportsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const reportType = requestParameters?.reportType;
    this.checkRequired('updateReportConfigurationReports', { reportType });
    return this.sendRequest(args, {
      method: 'put',
      path: `/organisation-management/admin/v1/reports/${this.configuration.encodeParam({ name: 'reportType', value: reportType, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.reportConfiguration,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Update Rule
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateRules(
    requestParameters?: UpdateRulesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<RulesRule>;
  public updateRules(
    requestParameters?: UpdateRulesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<RulesRule>>;
  public updateRules(
    requestParameters?: UpdateRulesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<RulesRule>>;
  public updateRules(requestParameters?: UpdateRulesParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateRules', { id });
    return this.sendRequest(args, {
      method: 'put',
      path: `/organisation-management/admin/v1/rules/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.rulesRule,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Validate Organisations
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public validateOrganisationsOrganisations(
    requestParameters?: ValidateOrganisationsOrganisationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ValidationResult>;
  public validateOrganisationsOrganisations(
    requestParameters?: ValidateOrganisationsOrganisationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ValidationResult>>;
  public validateOrganisationsOrganisations(
    requestParameters?: ValidateOrganisationsOrganisationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ValidationResult>>;
  public validateOrganisationsOrganisations(
    requestParameters?: ValidateOrganisationsOrganisationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-management/admin/v1/organisations/validate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.validateOrganisations,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }
}
